import { FC, memo, ReactNode } from 'react';
import 'dialog-polyfill/dialog-polyfill.css';
import './index.scss';

type TDialog = {
  className?: string;
  children?: ReactNode;
};

export const DialogInner: FC<TDialog> = memo(props => {
  const { children, className = '' } = props;

  return (
    <>
      <div className={`dialog__inner ${className}`}>{children}</div>
    </>
  );
});
